import React from "react";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const pages = [
  { page: "Home", route: "home" },
  { page: "About Us", route: "aboutus" },
  { page: "Our Services", route: "services" },
  { page: "Privacy Policy", route: "" },
  { page: "Terms", route: "" },
  { page: "Support", route: "" },
];

const Footer = () => {
  return (
    <Box
      sx={{
        l: 0,
        b: 0,
        w: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000",
        color: "#fff",
        p: 6,
      }}
    >
      <Typography sx={{ color: "#ccc" }}>
        © 2024 Helpsoo. All rights reserved.
      </Typography>
      <Box sx={{ display: { lg: "flex", xs: "block", md: "flex" }, pt: 2 }}>
        {pages.map((item) => {
          return (
            // <Link to={item.route} style={{ textDecoration: "none" }}>
            <Typography sx={{ color: "white", p: 2, textAlign: "center" }}>
              {item.page}
            </Typography>
            // </Link>
          );
        })}
        <Box
          sx={{
            width: { lg: 10, md: 10, xs: "100%" },
            height: { lg: 10, md: 10, xs: "1px" },
            backgroundColor: "rgba(255 ,255, 255, 0.2)",
            my: 3,
          }}
        ></Box>
        <TwitterIcon sx={{ p: 1.5 }} />
        <FacebookIcon sx={{ p: 1.5 }} />
        <InstagramIcon sx={{ p: 1.5 }} />
      </Box>
    </Box>
  );
};

export default Footer;
